import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styles from '../../../styles/general.module.scss';
import Status from '../../../components/status/Status';
import { renderInfoForType } from '../../../utils/helpers';

const RequestsTable = ({ data }) => (
  <table className={`${styles.table}`}>
    <thead>
      <tr>

        <th>
          <FormattedMessage id="gate.list.request_by" defaultMessage="Requested By" />
        </th>
        <th>
          <FormattedMessage id="gate.list.request_date" defaultMessage="Requested Date" />
        </th>
        <th>
          <FormattedMessage id="gate.list.flight" defaultMessage="Flight #" />
        </th>
        <th>
          <FormattedMessage id="gate.list.request_in" defaultMessage="Requested in-block" />
        </th>
        <th>
          <FormattedMessage id="gate.list.request_out" defaultMessage="Requested out-block" />
        </th>
        <th>
          <FormattedMessage id="gate.list.status" defaultMessage="Status" />
        </th>
        <th width="100" />
      </tr>
    </thead>
    <tbody>
      {
        Object.keys(data).map(e => (
          <>
            <tr>
              <td>{data[e]?.logged_by?.fullname}</td>
              <td className={styles.date}>
                {renderInfoForType({ type: 'datetime' }, data[e].requested_date, null, null)}
              </td>
              <td>{data[e].flight_number}</td>
              <td>
                {renderInfoForType({ type: 'datetime' }, data[e].in_date, null, null)}
              </td>
              <td>
                {renderInfoForType({ type: 'datetime' }, data[e].from_date, null, null)}
              </td>
              <td><Status item={data[e]?.status} /></td>
              <td>
                <Link to={`/gate_change/${data[e].id}/detail`}>
                  <FormattedMessage id="workorders.list.table.action" defaultMessage="View" />
                </Link>
              </td>
            </tr>
          </>
        ))}
    </tbody>
  </table>
);

RequestsTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default RequestsTable;
